module.exports = __webpack_public_path__ + "static/media/menu-logo.fd82c395.svg";